export enum CallType {
    INBOUND = "Входящий", OUTBOUND = "Исходящий"
}
